import _jsx from "@babel/runtime/helpers/jsx";
var _div, _p, _p2, _p3, _p4, _br, _p5, _p6;
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
const renderListItemLink = function (link, linkText, description) {
  if (linkText === void 0) {
    linkText = '';
  }
  if (description === void 0) {
    description = '';
  }
  return !!link && /*#__PURE__*/_jsx("li", {}, void 0, /*#__PURE__*/_jsx("a", {
    href: link
  }, void 0, linkText), ' ', "-", ' ', description);
};
function ErrorPage(_ref) {
  let {
    className,
    links = {
      homePage: '/',
      carDealers: '/car-dealers/',
      carResearch: '/research/?rdpage=SUBNAV',
      searchListings: '/cars-for-sale/',
      sellMyCar: '/sell-my-car/',
      sitemap: '/help/sitemap'
    },
    statusCode = 500,
    ...rest
  } = _ref;
  const containerClassName = clsx({
    'container margin-vertical margin-bottom-0': true
  }, className);
  const {
    homePage,
    carDealers,
    carResearch,
    searchListings,
    sellMyCar,
    sitemap
  } = links;
  const displayFollowLinksSection = !!carDealers || !!carResearch || !!searchListings || !!sellMyCar;
  let heading;

  // Assign statusCode specific messaging
  switch (statusCode) {
    case 404:
      heading = 'The page you requested is not available.';
      break;
    default:
      heading = 'Our site has experienced an error.';
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "ErrorPage"
  }, rest, {
    className: containerClassName
  }), /*#__PURE__*/_jsx("div", {
    className: "margin-horizontal-5"
  }, void 0, /*#__PURE__*/_jsx("h1", {
    className: "text-size-600 margin-vertical-5 text-bold"
  }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {}, void 0, "We're sorry.")), /*#__PURE__*/_jsx("div", {}, void 0, heading)), _p || (_p = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-2"
  }, void 0, "If you used a bookmark, the page may have been moved, or it no longer exists. If you typed in the URL, please check it and try again.")), _p2 || (_p2 = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-2"
  }, void 0, "You could also try one of the following options:")), /*#__PURE__*/_jsx("p", {}, void 0, "Check our", ' ', /*#__PURE__*/_jsx("a", {
    href: homePage
  }, void 0, "Homepage"), ' ', !!sitemap && /*#__PURE__*/React.createElement(React.Fragment, null, "or", ' ', /*#__PURE__*/_jsx("a", {
    href: sitemap
  }, void 0, "Site Map"), ' '), "to find what you need and reset your bookmark."), displayFollowLinksSection && /*#__PURE__*/React.createElement(React.Fragment, null, _p3 || (_p3 = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-5"
  }, void 0, "OR")), _p4 || (_p4 = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-5"
  }, void 0, "Follow one of the links below:")), /*#__PURE__*/_jsx("ul", {}, void 0, renderListItemLink(searchListings, 'Find Cars for Sale', 'Search listings in your area.'), renderListItemLink(carResearch, 'Car Research', 'Get prices, reviews & specs.'), renderListItemLink(sellMyCar, 'Sell Your Car', 'Place an ad or edit an existing ad.'), renderListItemLink(carDealers, 'Find Local Dealers', 'Search for dealers near you.')), _br || (_br = /*#__PURE__*/_jsx("br", {}))), _p5 || (_p5 = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-2"
  }, void 0, "This issue has been automatically reported to our Support team.")), _p6 || (_p6 = /*#__PURE__*/_jsx("p", {
    className: "margin-vertical-5"
  }, void 0, "If this problem persists, please call 1-866-AUTOTRADER (1-866-288-6872) Mon. - Fri.8 a.m.-8 p.m., Sat. 9 a.m. - 7 p.m. ET, or", ' ', /*#__PURE__*/_jsx("a", {
    href: "https://www.autotrader.com/help/email.jsp?contact_email=atc_feedback"
  }, void 0, "email us.")))));
}
export default ErrorPage;